import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

import { CookieConsentDialogComponent } from './components/cookie-consent-dialog/cookie-consent-dialog.component';
import { CookieConsentService } from './services/cookie-consent.service';

@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    TranslateModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatButtonModule,
  ],
  declarations: [CookieConsentDialogComponent],
})
export class CookieConsentFeatureModule {
  constructor(private dialog: MatDialog, private cookieConsentService: CookieConsentService) {
    if (!this.cookieConsentService.hasUserPreferences()) {
      this.dialog.open(CookieConsentDialogComponent, {
        width: '800px',
        maxWidth: '95vw',
        hasBackdrop: true,
        disableClose: false,
      });
    }
  }
}
